<template>
  <notifications
    position="right"
    classes="custom-notifications"
  />
  <router-view />
</template>

<script>
export default {
  name: 'App',
};
</script>

<style lang="scss" scoped>
  @font-face {
    font-family: "FordAntenna";
    src: local("FordAntenna"),
    url(./fonts/FordAntenna/FordAntenna-Regular.ttf) format("truetype");
  }
  @font-face {
    font-family: "FordAntennaBold";
    src: local("FordAntennaBold"),
    url(./fonts/FordAntenna/FordAntenna-Bold.ttf) format("truetype");
  }
  @font-face {
    font-family: "FordAntennaLight";
    src: local("FordAntennaLight"),
    url(./fonts/FordAntenna/FordAntenna-Light.ttf) format("truetype");
  }
  @font-face {
    font-family: "FordAntennaMedium";
    src: local("FordAntennaMedium"),
    url(./fonts/FordAntenna/FordAntenna-Medium.ttf) format("truetype");
  }
  @font-face {
    font-family: "FordAntennaRegular";
    src: local("FordAntennaRegular"),
    url(./fonts/FordAntenna/FordAntenna-Regular.ttf) format("truetype");
  }
  @font-face {
    font-family: "FordAntennaThin";
    src: local("FordAntennaThin"),
    url(./fonts/FordAntenna/FordAntenna-Thin.ttf) format("truetype");
  }
  @font-face {
    font-family: "FordAntennaCondensed";
    src: local("FordAntennaCondensed"),
    url(./fonts/FordAntenna/FordAntennaCond-Regular.ttf) format("truetype");
  }
  #home {
    margin: 0;
    padding: 0;
    font-family: "FordAntenna", Helvetica, Arial;
    overflow: hidden;
  }
</style>

<!--
According To Vue's Style Guide, The only proper way to add in global scss is if you want utilities or to apply every single style.
in this case it's here. Let me know if you guys want a few things changed.
-->
<style lang="scss">
  html, body, #app {
    width: 100%;
    height: 100%;
  }

  .notifications {
    top: 60px;
  }

  .custom-notifications {
    padding: 10px;
    margin-top: 5px;

    font-size: 14px;

    color: #FFFFFF;
    background: #44A4FC;
    border-right: 5px solid #187FE7;

    &.warn {
      background: #ffb648;
      border-right: #f48a06;
    }

    &.error {
      background: #E54D42;
      border-right: #B82E24;
    }

    &.success {
      background: #68CD86;
      border-right-color: #42A85F;
    }
  }

  .info {
    .icon {
      width: 30px;
      height: 30px;
      border-radius: 50% 50% 50% 0;
      background: #89849b;
      position: absolute;
      transform: rotate(-45deg);
      filter: drop-shadow(1px 4px 1px rgba(0, 0, 0, 0.5));

      &:after {
        content: '';
        width: 14px;
        height: 14px;
        margin: 8px 0 0 8px;
        background: white;
        position: absolute;
        border-radius: 50%;
      }

      &.red {
        background: #E8341C;
      }

      &.green {
        background: #10844F;
      }

      &.yellow {
        background: #FFFF00;
      }
    }

    &.highlight {
      z-index: 1;

      .details-container {
        display: flex;
      }
    }

    .details-container {
      display: none;
      flex-direction: column;
      position: absolute;
      transform: translateX(-159px);
      bottom: 0;
      width: 350px;
      background: #FFF;
      box-shadow: 1px 4px 9px 2px #b8b8b8;
      padding: 8px;
      border-radius: 4px;

      .close {
        background: #FFF;
        outline: none;
        border: none;
        width: fit-content;
        padding: 4px;
        margin-left: auto;
        margin-right: 4px;
      }

      .details {
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-size: 14px;

        a {
          width: fit-content;

          &:hover {
            opacity: 0.8;
          }
        }

        .flow-details {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 8px;

          .item {
            width: 50%;
            text-align: center;

            &.center {
              width: 100%;

              p:first-child {
                min-height: auto;
              }

              .item-flex {
                justify-content: center;
              }
            }

            p:first-child {
              min-height: 60px;
            }

            .item-flex {
              display: flex;
              gap: 4px;
              align-items: center;
            }
          }
        }
      }

    }
  }

  #legend {
    background: white;
    padding: 10px;
    margin: 10px;
    margin-top: 30px;
    border-radius: 5px;
    box-shadow: 0 2px 6px rgba(0,0,0,.3);
    z-index: 5; /* Ensures it's on top of the map */
    font-size: 1rem;

    .legend-disabled {
      position: relative;
      margin-left: 5px;
      padding: 8px;

      &::after {
        content: "";
        background: #999999;
        position: absolute;
        left: 0;
        top: 9px;
        width: 16px;
        height: 16px;
      }
    }
  }
</style>
